import React from "react";
import { withNavBars } from "../../HOCs";
import  UnitBlockingList  from "./unitBlocking";

class UnitBlockingParent extends React.Component {
    render() {
        return <UnitBlockingList />;
    }
}
const props = {
    boxShadow: false
}
export default withNavBars(UnitBlockingParent, props);